<template>
  <vs-tabs :position="isSmallerScreen ? 'top' : 'left'" class="tabs-shadow-none" id="profile-tabs" :key="isSmallerScreen">

    <!-- GENERAL -->
    <vs-tab icon-pack="feather" icon="icon-alert-octagon" :label="!isSmallerScreen ? '(a) Orders Errors' : ''">
      <div class="tab-general md:ml-4 md:mt-0 mt-4 ml-0">
        <orders-errors />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-alert-octagon" :label="!isSmallerScreen ? '(b) Products Errors' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <products-errors />
      </div>
    </vs-tab>
    <vs-tab icon-pack="feather" icon="icon-alert-octagon" :label="!isSmallerScreen ? '(c) Customers Errors' : ''">
      <div class="tab-info md:ml-4 md:mt-0 mt-4 ml-0">
        <customers-errors />
      </div>
    </vs-tab>    
  </vs-tabs>
</template>

<script>
import OrdersErrors from './OrdersErrors.vue'
import ProductsErrors from './ProductsErrors.vue'
import CustomersErrors from './CustomersErrors.vue'


export default {
  components: {    
    OrdersErrors,
    ProductsErrors,
    CustomersErrors,    
  },
  data () {
    return { 

    }
  },
  computed: {
    isSmallerScreen () {
      return this.$store.state.windowWidth < 768
    }
  }
}
</script>

<style lang="scss">
#profile-tabs {
  .vs-tabs--content {
    padding: 0;
  }
}
</style>
